<div class="flex flex-col mt-4 sm:mt-0 px-4 sm:px-0">
  <soft-date-picker
    class="date-picker"
    [value]="value() ?? today"
    (valueChange)="resolve($event)"
    #picker
  ></soft-date-picker>
</div>
